import { render, staticRenderFns } from "./contract-review.vue?vue&type=template&id=8bfc96a6&scoped=true"
import script from "./contract-review.vue?vue&type=script&lang=js"
export * from "./contract-review.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=8bfc96a6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfc96a6",
  null
  
)

export default component.exports